import _ from 'lodash';

export const initState = () => ({});

export const handleSwapSubcategory = (result) => (state) => {
  const cat = _.find(state.categories, { _id: result.catId });

  const subcat1Index = _.find(cat.subcategories, { _id: result.id1 }).index;
  const subcat2Index = _.find(cat.subcategories, { _id: result.id2 }).index;
  cat.subcategories = cat.subcategories.map((subcat) => {
    if (subcat1Index === subcat.index) {
      subcat.index = subcat2Index;
    } else if (subcat2Index === subcat.index) {
      subcat.index = subcat1Index;
    }
    return subcat;
  });
  cat.subcategories = _.orderBy(cat.subcategories, 'index');
  const newCategories = state.categories.map((category) => {
    if (category._id === result.catId) {
      return cat;
    }
    return category;
  });
  return { ...state, categories: newCategories };
};

export const handleSwapCategory = (result) => (state) => {
  const cat1Index = _.find(state.categories, { _id: result.id1 }).index;
  const cat2Index = _.find(state.categories, { _id: result.id2 }).index;
  const newCats = state.categories.map((cat) => {
    if (cat1Index === cat.index) {
      cat.index = cat2Index;
    } else if (cat2Index === cat.index) {
      cat.index = cat1Index;
    }
    return cat;
  });
  return { ...state, categories: newCats };
};
